import { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { fetchCurrencies, getCurrencies } from '../../../store/reducers/currencies'

import { ICurrency } from '../../../store/fetchers/currencies'

import { Pagination } from '../../../components/ui/pagination'

import styles from './styles.module.scss'
import SearchIcon from './icons/search.svg'
import ExchangeBuyItem from './exchange-buy-item'
import { useTranslation } from 'utils/use-translation'

export default function ExchangeBuy({ fromCurrency }) {
  const { t } = useTranslation()
  
  const dispatch = useAppDispatch()
  const currencies = useAppSelector(getCurrencies)
  const [currency, setCurrency] = useState<ICurrency>(null)
  const [sortedCurrencies, setSortedCurrencies] = useState<ICurrency[]>([])
  const [pagesCount, setPagesCount] = useState<number>(0)
  const [activePage, setActivePage] = useState<number>(1)
  const [filteredCurrencies, setFilteredCurrencies] = useState<ICurrency[]>([])
  const [searchText, setSearchText] = useState<string>('')
  const [searchedCurrencies, setSearchedCurrencies] = useState<ICurrency[]>([])

  useEffect(() => {
    if (dispatch) {
      dispatch(fetchCurrencies(true))
    }
  }, [dispatch])

  useEffect(() => {
    if (currencies.length) {
      setCurrency(
        currencies.find(
          (item) =>
            item.code.toUpperCase() === fromCurrency.ticker.toUpperCase() &&
            item.network.toUpperCase() === fromCurrency.network.toUpperCase(),
        ),
      )
      setSortedCurrencies(
        currencies.filter(
          (item) =>
            item.code.toUpperCase() !== fromCurrency.ticker.toUpperCase() &&
            item.network.toUpperCase() !== fromCurrency.network.toUpperCase() &&
            item.is_allowed_for_wallet,
        ),
      )
    }
  }, [currencies])

  useEffect(() => {
    if (sortedCurrencies.length) {
      setPagesCount(Math.ceil(sortedCurrencies.length / 10))
    }
  }, [sortedCurrencies])

  useEffect(() => {
    if (activePage === 1 && sortedCurrencies.length) {
      setFilteredCurrencies(searchedCurrencies.slice(0, 10))
    } else if (activePage === pagesCount) {
      setFilteredCurrencies(searchedCurrencies.slice((activePage - 1) * 10, sortedCurrencies.length))
    } else {
      setFilteredCurrencies(searchedCurrencies.slice((activePage - 1) * 10, activePage * 10))
    }
    setPagesCount(Math.ceil(searchedCurrencies.length / 10))
  }, [activePage, searchedCurrencies])

  useEffect(() => {
    if (searchText.trim() === '' && sortedCurrencies.length) {
      setSearchedCurrencies(sortedCurrencies)
      setActivePage(1)
    } else {
      setSearchedCurrencies(
        sortedCurrencies.filter((item) => item.code.toLowerCase().startsWith(searchText.toLowerCase())),
      )
      setActivePage(1)
    }
  }, [searchText, sortedCurrencies])

  const onSearchChange = (evt) => {
    setSearchText(evt.target.value)
  }

  return (
    <div className={styles.buy}>
      <div className={styles.search}>
        <img src={SearchIcon} alt="search icon" />
        <input type="text" placeholder={t('search_by_currency')} onChange={onSearchChange} />
      </div>

      <div className={styles.table__headers}>
        <p>{fromCurrency.ticker.toUpperCase()} {t('to')}</p>
        <p>{t('pair')}</p>
        <p>{t('available_for_exchange')}</p>
        <p>{t('action')}</p>
      </div>

      {filteredCurrencies.map((cur, index) => (
        <ExchangeBuyItem key={index} isGray={index % 2 === 0} firstCurrency={currency} secondCurrency={cur} />
      ))}
      <Pagination pagesCount={pagesCount} activePage={activePage} onPageChange={(page) => setActivePage(page)} />
    </div>
  )
}
